const ITEMS = [
  "ENGENHARIA PREDIAL",
  "GESTÃO TÉCNICA CONDOMINIAL",
  "RECUPERAÇÃO DE FACHADAS",
  "TRABALHO EM ALTURA",
  "FISCALIZAÇÃO DE OBRAS",
  "MANUTENÇÃO PREVENTIVA",
];

function Row({ hidden = false }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap font-display text-xl font-semibold tracking-[0.24em] text-slate-400 sm:text-2xl">
            {item}
          </span>
          <span className="mx-8 text-[10px] text-gold">◆</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="group overflow-hidden border-y border-gold/10 bg-navy-900/70 py-5">
      <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
